<script setup lang="ts">
import { type WithAttributes, fw } from './attributes'

// #region props
const props = defineProps <WithAttributes <{
  class: {
    color?: any
  }
}
>>()
// #endregion props
</script>

<template>
  <span
    :class="[props.class ?? 'color-default-solid', $style.badge, fw.shape.circle]"
    role="status"
  >
    <slot />
  </span>
</template>

<style module>
  .badge {
    position: absolute;
    inset: var(--badge-inset);
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    font-size: 12px;
    font-weight: 700;
    line-height: 20px;

    &:empty {
        display: none;
    }
  }
</style>
